import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FeatherIcon, PlusIcon, LogOutIcon, EditIcon, TrashIcon, SearchIcon, ChevronLeftIcon, ChevronRightIcon, BookOpenIcon, AlertCircleIcon, LayoutIcon, SettingsIcon, FileIcon, UploadIcon, CodeIcon, TagIcon, ImageIcon, HomeIcon, UsersIcon, MessageSquareIcon, PackageIcon, MenuIcon, XIcon } from 'lucide-react';
interface BlogPost {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
}
// Mock data for when the API is not available
const mockPosts: BlogPost[] = [{
  id: '1',
  title: 'The Art of Brand Storytelling in East Africa',
  category: 'Brand Strategy',
  date: 'June 12, 2023',
  author: 'Kibaki Muthamia'
}, {
  id: '2',
  title: 'Digital Content Strategies for the Kenyan Market',
  category: 'Digital Content',
  date: 'May 24, 2023',
  author: 'Kibaki Muthamia'
}, {
  id: '3',
  title: 'The Rise of Native Advertising in African Media',
  category: 'Content Marketing',
  date: 'April 18, 2023',
  author: 'Kibaki Muthamia'
}];
export function AdminDashboard() {
  const [posts, setPosts] = useState<BlogPost[]>(mockPosts);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [confirmDelete, setConfirmDelete] = useState<string | null>(null);
  const [userName, setUserName] = useState('Kibaki Muthamia');
  const [activeSection, setActiveSection] = useState('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const storedName = localStorage.getItem('userName');
    if (storedName) {
      setUserName(storedName);
    }
    // We'll use mock data instead of fetching from API
  }, []);
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userName');
    navigate('/admin/login');
  };
  const handleDeletePost = async (id: string) => {
    try {
      // For demo, just remove from state
      setPosts(posts.filter(post => post.id !== id));
      setConfirmDelete(null);
    } catch (err: any) {
      setError(err.message || 'Failed to delete post');
    }
  };
  const filteredPosts = posts.filter(post => post.title.toLowerCase().includes(searchTerm.toLowerCase()) || post.category.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-526">
      {/* Sidebar */}
      <div className="hidden md:flex flex-col w-64 bg-gray-800 text-white" data-id="element-527">
        <div className="p-5 flex items-center border-b border-gray-700" data-id="element-528">
          <FeatherIcon size={24} className="text-amber-500 mr-3" data-id="element-529" />
          <h1 className="text-xl font-bold" data-id="element-530">Muthamia Admin</h1>
        </div>
        <nav className="flex-1 overflow-y-auto py-4" data-id="element-531">
          <div className="px-4 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-532">
            Main
          </div>
          <button onClick={() => setActiveSection('dashboard')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'dashboard' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-533">
            <HomeIcon size={18} className="mr-3" data-id="element-534" />
            <span data-id="element-535">Dashboard</span>
          </button>
          <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-536">
            Content
          </div>
          <button onClick={() => setActiveSection('posts')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'posts' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-537">
            <BookOpenIcon size={18} className="mr-3" data-id="element-538" />
            <span data-id="element-539">Posts</span>
          </button>
          <button onClick={() => setActiveSection('media')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'media' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-540">
            <ImageIcon size={18} className="mr-3" data-id="element-541" />
            <span data-id="element-542">Media</span>
          </button>
          <button onClick={() => setActiveSection('comments')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'comments' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-543">
            <MessageSquareIcon size={18} className="mr-3" data-id="element-544" />
            <span data-id="element-545">Comments</span>
          </button>
          <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-546">
            Appearance
          </div>
          <button onClick={() => setActiveSection('header')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'header' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-547">
            <LayoutIcon size={18} className="mr-3" data-id="element-548" />
            <span data-id="element-549">Header</span>
          </button>
          <button onClick={() => setActiveSection('code')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'code' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-550">
            <CodeIcon size={18} className="mr-3" data-id="element-551" />
            <span data-id="element-552">Custom Code</span>
          </button>
          <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-553">
            Settings
          </div>
          <button onClick={() => setActiveSection('seo')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'seo' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-554">
            <TagIcon size={18} className="mr-3" data-id="element-555" />
            <span data-id="element-556">SEO</span>
          </button>
          <button onClick={() => setActiveSection('users')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'users' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-557">
            <UsersIcon size={18} className="mr-3" data-id="element-558" />
            <span data-id="element-559">Users</span>
          </button>
          <button onClick={() => setActiveSection('settings')} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'settings' ? 'bg-gray-700 text-amber-400' : 'text-gray-300 hover:bg-gray-700'}`} data-id="element-560">
            <SettingsIcon size={18} className="mr-3" data-id="element-561" />
            <span data-id="element-562">General Settings</span>
          </button>
        </nav>
        <div className="p-4 border-t border-gray-700" data-id="element-563">
          <button onClick={handleLogout} className="flex items-center text-gray-300 hover:text-white w-full" data-id="element-564">
            <LogOutIcon size={18} className="mr-3" data-id="element-565" />
            <span data-id="element-566">Logout</span>
          </button>
        </div>
      </div>
      {/* Mobile menu button */}
      <div className="md:hidden fixed top-0 left-0 z-40 w-full bg-gray-800 text-white p-4 flex justify-between items-center" data-id="element-567">
        <div className="flex items-center" data-id="element-568">
          <FeatherIcon size={24} className="text-amber-500 mr-3" data-id="element-569" />
          <h1 className="text-lg font-bold" data-id="element-570">Muthamia Admin</h1>
        </div>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white focus:outline-none" data-id="element-571">
          {mobileMenuOpen ? <XIcon size={24} data-id="element-572" /> : <MenuIcon size={24} data-id="element-573" />}
        </button>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden fixed inset-0 z-30 bg-gray-800 pt-16 overflow-y-auto" data-id="element-574">
          <nav className="py-4" data-id="element-575">
            <div className="px-4 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-576">
              Main
            </div>
            <button onClick={() => {
          setActiveSection('dashboard');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'dashboard' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-577">
              <HomeIcon size={18} className="mr-3" data-id="element-578" />
              <span data-id="element-579">Dashboard</span>
            </button>
            <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-580">
              Content
            </div>
            <button onClick={() => {
          setActiveSection('posts');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'posts' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-581">
              <BookOpenIcon size={18} className="mr-3" data-id="element-582" />
              <span data-id="element-583">Posts</span>
            </button>
            <button onClick={() => {
          setActiveSection('media');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'media' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-584">
              <ImageIcon size={18} className="mr-3" data-id="element-585" />
              <span data-id="element-586">Media</span>
            </button>
            <button onClick={() => {
          setActiveSection('comments');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'comments' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-587">
              <MessageSquareIcon size={18} className="mr-3" data-id="element-588" />
              <span data-id="element-589">Comments</span>
            </button>
            <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-590">
              Appearance
            </div>
            <button onClick={() => {
          setActiveSection('header');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'header' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-591">
              <LayoutIcon size={18} className="mr-3" data-id="element-592" />
              <span data-id="element-593">Header</span>
            </button>
            <button onClick={() => {
          setActiveSection('code');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'code' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-594">
              <CodeIcon size={18} className="mr-3" data-id="element-595" />
              <span data-id="element-596">Custom Code</span>
            </button>
            <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-597">
              Settings
            </div>
            <button onClick={() => {
          setActiveSection('seo');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'seo' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-598">
              <TagIcon size={18} className="mr-3" data-id="element-599" />
              <span data-id="element-600">SEO</span>
            </button>
            <button onClick={() => {
          setActiveSection('users');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'users' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-601">
              <UsersIcon size={18} className="mr-3" data-id="element-602" />
              <span data-id="element-603">Users</span>
            </button>
            <button onClick={() => {
          setActiveSection('settings');
          setMobileMenuOpen(false);
        }} className={`flex items-center px-4 py-3 w-full text-left ${activeSection === 'settings' ? 'bg-gray-700 text-amber-400' : 'text-gray-300'}`} data-id="element-604">
              <SettingsIcon size={18} className="mr-3" data-id="element-605" />
              <span data-id="element-606">General Settings</span>
            </button>
            <div className="px-4 mt-6 border-t border-gray-700 pt-4" data-id="element-607">
              <button onClick={handleLogout} className="flex items-center text-gray-300 hover:text-white w-full py-3" data-id="element-608">
                <LogOutIcon size={18} className="mr-3" data-id="element-609" />
                <span data-id="element-610">Logout</span>
              </button>
            </div>
          </nav>
        </div>}
      {/* Main Content */}
      <div className="flex-1 md:ml-64 md:mt-0 mt-16" data-id="element-611">
        {/* Header */}
        <header className="bg-white shadow-sm p-4" data-id="element-612">
          <div className="flex justify-between items-center" data-id="element-613">
            <h1 className="text-xl font-bold text-gray-900" data-id="element-614">
              {activeSection === 'dashboard' && 'Dashboard'}
              {activeSection === 'posts' && 'Posts'}
              {activeSection === 'media' && 'Media Library'}
              {activeSection === 'comments' && 'Comments'}
              {activeSection === 'header' && 'Header Editor'}
              {activeSection === 'code' && 'Custom Code'}
              {activeSection === 'seo' && 'SEO Settings'}
              {activeSection === 'users' && 'User Management'}
              {activeSection === 'settings' && 'General Settings'}
            </h1>
            <div className="flex items-center" data-id="element-615">
              <span className="mr-4 text-gray-600 hidden sm:inline-block" data-id="element-616">
                Welcome, {userName}
              </span>
              <button onClick={handleLogout} className="flex items-center text-gray-600 hover:text-gray-900 md:hidden" data-id="element-617">
                <LogOutIcon size={18} className="mr-1" data-id="element-618" />
                <span data-id="element-619">Logout</span>
              </button>
            </div>
          </div>
        </header>
        {/* Dashboard Content */}
        {activeSection === 'dashboard' && <div className="p-6" data-id="element-620">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-621">
              <div className="bg-white rounded-lg shadow p-6" data-id="element-622">
                <div className="flex items-center" data-id="element-623">
                  <div className="rounded-full bg-blue-100 p-3 mr-4" data-id="element-624">
                    <BookOpenIcon size={24} className="text-blue-600" data-id="element-625" />
                  </div>
                  <div data-id="element-626">
                    <h3 className="text-gray-500 text-sm" data-id="element-627">Total Posts</h3>
                    <p className="text-2xl font-bold" data-id="element-628">{posts.length}</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow p-6" data-id="element-629">
                <div className="flex items-center" data-id="element-630">
                  <div className="rounded-full bg-green-100 p-3 mr-4" data-id="element-631">
                    <UsersIcon size={24} className="text-green-600" data-id="element-632" />
                  </div>
                  <div data-id="element-633">
                    <h3 className="text-gray-500 text-sm" data-id="element-634">Users</h3>
                    <p className="text-2xl font-bold" data-id="element-635">1</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow p-6" data-id="element-636">
                <div className="flex items-center" data-id="element-637">
                  <div className="rounded-full bg-purple-100 p-3 mr-4" data-id="element-638">
                    <MessageSquareIcon size={24} className="text-purple-600" data-id="element-639" />
                  </div>
                  <div data-id="element-640">
                    <h3 className="text-gray-500 text-sm" data-id="element-641">Comments</h3>
                    <p className="text-2xl font-bold" data-id="element-642">0</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow p-6" data-id="element-643">
                <div className="flex items-center" data-id="element-644">
                  <div className="rounded-full bg-amber-100 p-3 mr-4" data-id="element-645">
                    <ImageIcon size={24} className="text-amber-600" data-id="element-646" />
                  </div>
                  <div data-id="element-647">
                    <h3 className="text-gray-500 text-sm" data-id="element-648">Media Files</h3>
                    <p className="text-2xl font-bold" data-id="element-649">0</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-6 mb-8" data-id="element-650">
              <h2 className="text-lg font-bold mb-4" data-id="element-651">Recent Activity</h2>
              <div className="border-b pb-4 mb-4" data-id="element-652">
                <p className="text-gray-600" data-id="element-653">No recent activity to display.</p>
              </div>
              <Link to="/admin/blog/create" className="flex items-center text-amber-600 hover:text-amber-800" data-id="element-654">
                <PlusIcon size={16} className="mr-2" data-id="element-655" />
                <span data-id="element-656">Create your first post</span>
              </Link>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-657">
              <div className="bg-white rounded-lg shadow p-6" data-id="element-658">
                <h2 className="text-lg font-bold mb-4" data-id="element-659">Quick Draft</h2>
                <div className="mb-4" data-id="element-660">
                  <input type="text" placeholder="Title" className="w-full p-2 border border-gray-300 rounded mb-3" data-id="element-661" />
                  <textarea placeholder="Content" className="w-full p-2 border border-gray-300 rounded h-32" data-id="element-662"></textarea>
                </div>
                <button className="bg-amber-600 text-white px-4 py-2 rounded hover:bg-amber-700" data-id="element-663">
                  Save Draft
                </button>
              </div>
              <div className="bg-white rounded-lg shadow p-6" data-id="element-664">
                <h2 className="text-lg font-bold mb-4" data-id="element-665">Site Health</h2>
                <div className="flex items-center mb-4" data-id="element-666">
                  <div className="w-3 h-3 rounded-full bg-green-500 mr-2" data-id="element-667"></div>
                  <span className="text-gray-700" data-id="element-668">SEO: Good</span>
                </div>
                <div className="flex items-center mb-4" data-id="element-669">
                  <div className="w-3 h-3 rounded-full bg-green-500 mr-2" data-id="element-670"></div>
                  <span className="text-gray-700" data-id="element-671">Security: Good</span>
                </div>
                <div className="flex items-center mb-4" data-id="element-672">
                  <div className="w-3 h-3 rounded-full bg-yellow-500 mr-2" data-id="element-673"></div>
                  <span className="text-gray-700" data-id="element-674">Performance: Fair</span>
                </div>
                <button onClick={() => setActiveSection('settings')} className="text-amber-600 hover:text-amber-800 mt-2" data-id="element-675">
                  View details
                </button>
              </div>
            </div>
          </div>}
        {/* Posts Section */}
        {activeSection === 'posts' && <div className="p-6" data-id="element-676">
            <div className="mb-6 flex justify-between items-center" data-id="element-677">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-678">Blog Posts</h2>
              <Link to="/admin/blog/create" className="flex items-center bg-amber-600 text-white px-4 py-2 rounded-md hover:bg-amber-700 transition-colors" data-id="element-679">
                <PlusIcon size={18} className="mr-2" data-id="element-680" />
                <span data-id="element-681">New Post</span>
              </Link>
            </div>
            {/* Search */}
            <div className="mb-6" data-id="element-682">
              <div className="relative" data-id="element-683">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-684">
                  <SearchIcon size={18} className="text-gray-400" data-id="element-685" />
                </div>
                <input type="text" placeholder="Search posts by title or category..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-686" />
              </div>
            </div>
            {/* Error Message */}
            {error && <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-md flex items-center" data-id="element-687">
                <AlertCircleIcon size={20} className="mr-2" data-id="element-688" />
                <span data-id="element-689">{error}</span>
              </div>}
            {/* Posts Table */}
            {loading ? <div className="flex justify-center py-8" data-id="element-690">
                <div className="w-12 h-12 border-t-4 border-amber-600 border-solid rounded-full animate-spin" data-id="element-691"></div>
              </div> : filteredPosts.length > 0 ? <div className="bg-white shadow-md rounded-lg overflow-hidden" data-id="element-692">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-693">
                  <thead className="bg-gray-50" data-id="element-694">
                    <tr data-id="element-695">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-696">
                        Title
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-697">
                        Category
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-698">
                        Date
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-699">
                        Author
                      </th>
                      <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-700">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-701">
                    {filteredPosts.map(post => <tr key={post.id} className="hover:bg-gray-50" data-id="element-702">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-703">
                          <div className="flex items-center" data-id="element-704">
                            <BookOpenIcon size={18} className="text-amber-600 mr-2" data-id="element-705" />
                            <div className="text-sm font-medium text-gray-900 truncate max-w-xs" data-id="element-706">
                              {post.title}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-707">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-amber-100 text-amber-800" data-id="element-708">
                            {post.category}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-709">
                          {post.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-710">
                          {post.author}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-711">
                          {confirmDelete === post.id ? <div className="flex items-center justify-end space-x-2" data-id="element-712">
                              <span className="text-gray-600" data-id="element-713">
                                Confirm delete?
                              </span>
                              <button onClick={() => handleDeletePost(post.id)} className="text-red-600 hover:text-red-800" data-id="element-714">
                                Yes
                              </button>
                              <button onClick={() => setConfirmDelete(null)} className="text-gray-600 hover:text-gray-800" data-id="element-715">
                                No
                              </button>
                            </div> : <div className="flex items-center justify-end space-x-3" data-id="element-716">
                              <Link to={`/admin/blog/edit/${post.id}`} className="text-amber-600 hover:text-amber-800" data-id="element-717">
                                <EditIcon size={18} data-id="element-718" />
                              </Link>
                              <button onClick={() => setConfirmDelete(post.id)} className="text-red-600 hover:text-red-800" data-id="element-719">
                                <TrashIcon size={18} data-id="element-720" />
                              </button>
                            </div>}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div> : <div className="text-center py-8 bg-white rounded-lg shadow-md" data-id="element-721">
                <BookOpenIcon size={48} className="mx-auto text-gray-300 mb-4" data-id="element-722" />
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-723">
                  No posts found
                </h3>
                <p className="text-gray-500" data-id="element-724">
                  {searchTerm ? `No posts matching "${searchTerm}"` : "You haven't created any blog posts yet"}
                </p>
                {searchTerm && <button onClick={() => setSearchTerm('')} className="mt-4 text-amber-600 hover:text-amber-800" data-id="element-725">
                    Clear search
                  </button>}
              </div>}
          </div>}
        {/* Media Library */}
        {activeSection === 'media' && <div className="p-6" data-id="element-726">
            <div className="mb-6 flex justify-between items-center" data-id="element-727">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-728">
                Media Library
              </h2>
              <button className="flex items-center bg-amber-600 text-white px-4 py-2 rounded-md hover:bg-amber-700 transition-colors" data-id="element-729">
                <UploadIcon size={18} className="mr-2" data-id="element-730" />
                <span data-id="element-731">Upload New</span>
              </button>
            </div>
            <div className="bg-white shadow-md rounded-lg p-8 text-center" data-id="element-732">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-12 mb-6" data-id="element-733">
                <ImageIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-734" />
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-735">
                  No media files yet
                </h3>
                <p className="text-gray-500 mb-6" data-id="element-736">
                  Drag and drop files here or use the upload button
                </p>
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-737">
                  Select Files
                </button>
              </div>
              <p className="text-sm text-gray-500" data-id="element-738">
                Supported formats: JPEG, PNG, GIF, SVG, MP4, PDF, DOCX
              </p>
            </div>
          </div>}
        {/* Comments */}
        {activeSection === 'comments' && <div className="p-6" data-id="element-739">
            <div className="mb-6" data-id="element-740">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-741">Comments</h2>
              <p className="text-gray-600 mt-2" data-id="element-742">
                Manage comments on your blog posts
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg p-8 text-center" data-id="element-743">
              <MessageSquareIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-744" />
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-745">
                No comments yet
              </h3>
              <p className="text-gray-500" data-id="element-746">
                When you receive comments, they'll appear here for moderation
              </p>
            </div>
          </div>}
        {/* Header Editor */}
        {activeSection === 'header' && <div className="p-6" data-id="element-747">
            <div className="mb-6" data-id="element-748">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-749">
                Header Editor
              </h2>
              <p className="text-gray-600 mt-2" data-id="element-750">
                Customize your website header
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6" data-id="element-751">
              <div className="mb-6" data-id="element-752">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-753">
                  Logo
                </label>
                <div className="flex items-center" data-id="element-754">
                  <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center mr-4" data-id="element-755">
                    <FeatherIcon size={24} className="text-amber-600" data-id="element-756" />
                  </div>
                  <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors" data-id="element-757">
                    Change Logo
                  </button>
                </div>
              </div>
              <div className="mb-6" data-id="element-758">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-759">
                  Site Title
                </label>
                <input type="text" defaultValue="Muthamia Content" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-760" />
              </div>
              <div className="mb-6" data-id="element-761">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-762">
                  Navigation Menu
                </label>
                <div className="border border-gray-300 rounded-md p-4" data-id="element-763">
                  <div className="flex justify-between items-center p-2 bg-gray-50 mb-2 rounded" data-id="element-764">
                    <span data-id="element-765">Home</span>
                    <div className="flex space-x-2" data-id="element-766">
                      <button className="text-gray-500 hover:text-amber-600" data-id="element-767">
                        <EditIcon size={16} data-id="element-768" />
                      </button>
                      <button className="text-gray-500 hover:text-red-600" data-id="element-769">
                        <TrashIcon size={16} data-id="element-770" />
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-2 bg-gray-50 mb-2 rounded" data-id="element-771">
                    <span data-id="element-772">Portfolio</span>
                    <div className="flex space-x-2" data-id="element-773">
                      <button className="text-gray-500 hover:text-amber-600" data-id="element-774">
                        <EditIcon size={16} data-id="element-775" />
                      </button>
                      <button className="text-gray-500 hover:text-red-600" data-id="element-776">
                        <TrashIcon size={16} data-id="element-777" />
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-2 bg-gray-50 mb-2 rounded" data-id="element-778">
                    <span data-id="element-779">Blog</span>
                    <div className="flex space-x-2" data-id="element-780">
                      <button className="text-gray-500 hover:text-amber-600" data-id="element-781">
                        <EditIcon size={16} data-id="element-782" />
                      </button>
                      <button className="text-gray-500 hover:text-red-600" data-id="element-783">
                        <TrashIcon size={16} data-id="element-784" />
                      </button>
                    </div>
                  </div>
                  <button className="flex items-center text-amber-600 hover:text-amber-800 mt-2" data-id="element-785">
                    <PlusIcon size={16} className="mr-1" data-id="element-786" />
                    <span data-id="element-787">Add Menu Item</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-788">
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-789">
                  Save Changes
                </button>
              </div>
            </div>
          </div>}
        {/* Custom Code */}
        {activeSection === 'code' && <div className="p-6" data-id="element-790">
            <div className="mb-6" data-id="element-791">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-792">Custom Code</h2>
              <p className="text-gray-600 mt-2" data-id="element-793">
                Add custom HTML, CSS, or JavaScript to your site
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6" data-id="element-794">
              <div className="mb-6" data-id="element-795">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-796">
                  Header Code (before &lt;/head&gt;)
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 font-mono text-sm h-40" placeholder="<!-- Add custom meta tags, analytics, or CSS here -->" data-id="element-797"></textarea>
                <p className="text-sm text-gray-500 mt-1" data-id="element-798">
                  This code will be added before the closing head tag on all
                  pages.
                </p>
              </div>
              <div className="mb-6" data-id="element-799">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-800">
                  Body Code (after &lt;body&gt;)
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 font-mono text-sm h-40" placeholder="<!-- Add scripts that should load at the beginning of the body -->" data-id="element-801"></textarea>
                <p className="text-sm text-gray-500 mt-1" data-id="element-802">
                  This code will be added immediately after the opening body
                  tag.
                </p>
              </div>
              <div className="mb-6" data-id="element-803">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-804">
                  Footer Code (before &lt;/body&gt;)
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 font-mono text-sm h-40" placeholder="<!-- Add tracking codes, scripts, or other elements here -->" data-id="element-805"></textarea>
                <p className="text-sm text-gray-500 mt-1" data-id="element-806">
                  This code will be added before the closing body tag on all
                  pages.
                </p>
              </div>
              <div className="flex justify-end" data-id="element-807">
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-808">
                  Save Changes
                </button>
              </div>
            </div>
          </div>}
        {/* SEO Settings */}
        {activeSection === 'seo' && <div className="p-6" data-id="element-809">
            <div className="mb-6" data-id="element-810">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-811">SEO Settings</h2>
              <p className="text-gray-600 mt-2" data-id="element-812">
                Optimize your site for search engines
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6 mb-6" data-id="element-813">
              <h3 className="text-lg font-bold mb-4" data-id="element-814">Global SEO</h3>
              <div className="mb-6" data-id="element-815">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-816">
                  Site Title
                </label>
                <input type="text" defaultValue="Muthamia Content | Brand Strategy Meets Storytelling" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-817" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-818">
                  This appears in search results and browser tabs.
                </p>
              </div>
              <div className="mb-6" data-id="element-819">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-820">
                  Meta Description
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 h-24" defaultValue="Empowering brands to communicate boldly, natively, and intelligently. Content creation and brand strategy services in East Africa." data-id="element-821"></textarea>
                <p className="text-sm text-gray-500 mt-1" data-id="element-822">
                  This appears in search results below the title (150-160
                  characters recommended).
                </p>
              </div>
              <div className="mb-6" data-id="element-823">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-824">
                  Keywords
                </label>
                <input type="text" defaultValue="content creation, brand strategy, storytelling, East Africa, content marketing" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-825" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-826">
                  Comma-separated keywords (less important for modern SEO).
                </p>
              </div>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6 mb-6" data-id="element-827">
              <h3 className="text-lg font-bold mb-4" data-id="element-828">Social Media</h3>
              <div className="mb-6" data-id="element-829">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-830">
                  Open Graph Title
                </label>
                <input type="text" defaultValue="Muthamia Content | Brand Storytelling Experts" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-831" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-832">
                  Title used when sharing on social media.
                </p>
              </div>
              <div className="mb-6" data-id="element-833">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-834">
                  Open Graph Description
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 h-24" defaultValue="We help brands tell their stories through high-impact content, strategy, and native intelligence." data-id="element-835"></textarea>
                <p className="text-sm text-gray-500 mt-1" data-id="element-836">
                  Description used when sharing on social media.
                </p>
              </div>
              <div className="mb-6" data-id="element-837">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-838">
                  Social Image
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-839">
                  <ImageIcon size={36} className="mx-auto text-gray-400 mb-2" data-id="element-840" />
                  <p className="text-sm text-gray-500 mb-3" data-id="element-841">
                    Recommended size: 1200 x 630 pixels
                  </p>
                  <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors" data-id="element-842">
                    Upload Image
                  </button>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6" data-id="element-843">
              <h3 className="text-lg font-bold mb-4" data-id="element-844">Advanced</h3>
              <div className="mb-6" data-id="element-845">
                <div className="flex items-center" data-id="element-846">
                  <input type="checkbox" id="robots" className="h-4 w-4 text-amber-600 border-gray-300 rounded focus:ring-amber-500" defaultChecked data-id="element-847" />
                  <label htmlFor="robots" className="ml-2 text-gray-700" data-id="element-848">
                    Allow search engines to index this site
                  </label>
                </div>
              </div>
              <div className="mb-6" data-id="element-849">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-850">
                  Google Analytics ID
                </label>
                <input type="text" placeholder="UA-XXXXXXXXX-X or G-XXXXXXXXXX" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-851" />
              </div>
              <div className="mb-6" data-id="element-852">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-853">
                  Google Search Console Verification
                </label>
                <input type="text" placeholder="Meta tag content value" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-854" />
              </div>
              <div className="flex justify-end" data-id="element-855">
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-856">
                  Save SEO Settings
                </button>
              </div>
            </div>
          </div>}
        {/* Users */}
        {activeSection === 'users' && <div className="p-6" data-id="element-857">
            <div className="mb-6" data-id="element-858">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-859">
                User Management
              </h2>
              <p className="text-gray-600 mt-2" data-id="element-860">
                Manage users and their permissions
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg overflow-hidden mb-6" data-id="element-861">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-862">
                <thead className="bg-gray-50" data-id="element-863">
                  <tr data-id="element-864">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-865">
                      Name
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-866">
                      Username
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-867">
                      Role
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-868">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-869">
                  <tr data-id="element-870">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-871">
                      <div className="flex items-center" data-id="element-872">
                        <div className="flex-shrink-0 h-10 w-10 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-873">
                          <span className="text-amber-800 font-medium" data-id="element-874">KM</span>
                        </div>
                        <div className="ml-4" data-id="element-875">
                          <div className="text-sm font-medium text-gray-900" data-id="element-876">
                            Kibaki Muthamia
                          </div>
                          <div className="text-sm text-gray-500" data-id="element-877">
                            admin@example.com
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-878">
                      admin
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-879">
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-880">
                        Administrator
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-881">
                      <button className="text-amber-600 hover:text-amber-800 mr-3" data-id="element-882">
                        Edit
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6" data-id="element-883">
              <h3 className="text-lg font-bold mb-4" data-id="element-884">Add New User</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-885">
                <div data-id="element-886">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-887">
                    Name
                  </label>
                  <input type="text" placeholder="Full Name" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-888" />
                </div>
                <div data-id="element-889">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-890">
                    Email
                  </label>
                  <input type="email" placeholder="Email Address" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-891" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-892">
                <div data-id="element-893">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-894">
                    Username
                  </label>
                  <input type="text" placeholder="Username" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-895" />
                </div>
                <div data-id="element-896">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-897">
                    Role
                  </label>
                  <select className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-898">
                    <option data-id="element-899">Administrator</option>
                    <option data-id="element-900">Editor</option>
                    <option data-id="element-901">Author</option>
                    <option data-id="element-902">Contributor</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-903">
                <div data-id="element-904">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-905">
                    Password
                  </label>
                  <input type="password" placeholder="Password" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-906" />
                </div>
                <div data-id="element-907">
                  <label className="block text-gray-700 font-medium mb-2" data-id="element-908">
                    Confirm Password
                  </label>
                  <input type="password" placeholder="Confirm Password" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-909" />
                </div>
              </div>
              <div className="flex justify-end" data-id="element-910">
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-911">
                  Add User
                </button>
              </div>
            </div>
          </div>}
        {/* General Settings */}
        {activeSection === 'settings' && <div className="p-6" data-id="element-912">
            <div className="mb-6" data-id="element-913">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-914">
                General Settings
              </h2>
              <p className="text-gray-600 mt-2" data-id="element-915">
                Configure your website settings
              </p>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6 mb-6" data-id="element-916">
              <h3 className="text-lg font-bold mb-4" data-id="element-917">Site Identity</h3>
              <div className="mb-6" data-id="element-918">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-919">
                  Site Title
                </label>
                <input type="text" defaultValue="Muthamia Content" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-920" />
              </div>
              <div className="mb-6" data-id="element-921">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-922">
                  Tagline
                </label>
                <input type="text" defaultValue="Brand Strategy Meets Storytelling" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-923" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-924">
                  In a few words, explain what this site is about.
                </p>
              </div>
              <div className="mb-6" data-id="element-925">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-926">
                  Site Icon (Favicon)
                </label>
                <div className="flex items-center" data-id="element-927">
                  <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center mr-4" data-id="element-928">
                    <FeatherIcon size={24} className="text-amber-600" data-id="element-929" />
                  </div>
                  <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors" data-id="element-930">
                    Change Icon
                  </button>
                </div>
                <p className="text-sm text-gray-500 mt-1" data-id="element-931">
                  Site Icon should be square, at least 512×512 pixels.
                </p>
              </div>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6 mb-6" data-id="element-932">
              <h3 className="text-lg font-bold mb-4" data-id="element-933">Contact Information</h3>
              <div className="mb-6" data-id="element-934">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-935">
                  Email Address
                </label>
                <input type="email" defaultValue="contact@muthamiacontent.com" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-936" />
              </div>
              <div className="mb-6" data-id="element-937">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-938">
                  Phone Number
                </label>
                <input type="tel" defaultValue="+254 123 456 789" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-939" />
              </div>
              <div className="mb-6" data-id="element-940">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-941">
                  Address
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 h-24" defaultValue="Nairobi, Kenya" data-id="element-942"></textarea>
              </div>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6" data-id="element-943">
              <h3 className="text-lg font-bold mb-4" data-id="element-944">Social Media Profiles</h3>
              <div className="mb-6" data-id="element-945">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-946">
                  Facebook
                </label>
                <input type="url" placeholder="https://facebook.com/yourpage" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-947" />
              </div>
              <div className="mb-6" data-id="element-948">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-949">
                  Twitter
                </label>
                <input type="url" placeholder="https://twitter.com/yourhandle" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-950" />
              </div>
              <div className="mb-6" data-id="element-951">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-952">
                  Instagram
                </label>
                <input type="url" placeholder="https://instagram.com/yourhandle" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-953" />
              </div>
              <div className="mb-6" data-id="element-954">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-955">
                  LinkedIn
                </label>
                <input type="url" placeholder="https://linkedin.com/company/yourcompany" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-956" />
              </div>
              <div className="flex justify-end" data-id="element-957">
                <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition-colors" data-id="element-958">
                  Save Settings
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}